/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdateFeedbackLangRequestViewModel } from "../types/UpdateFeedbackLangRequestViewModel.ts";

export const updateFeedbackLangRequestViewModelSchema = z.object({
  cultureInfo: z.string().nullish(),
  description: z.string().nullish(),
}) as unknown as ToZod<UpdateFeedbackLangRequestViewModel>;
